import { SvgIcon } from '@mui/material';

const Menu = () => (
  <SvgIcon
    viewBox="0 0 18 12"
    xmlns="http://www.w3.org/2000/svg"
    sx={{ width: 18, height: 12, fill: 'none' }}
    data-testid="umbrellaIcon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12H18V10H0V12ZM0 7H18V5H0V7ZM0 0V2H18V0H0Z"
      fill="#0B1421"
    />
  </SvgIcon>
);

export default Menu;
